import React from 'react';
import { Phone, MapPin, Clock, Facebook, Instagram, Mail } from 'lucide-react';

const RESTAURANT_INFO = {
  name: 'Rumah Makan Aroma Cempaka',
  phone: '+62 851-6998-6774',
  openHours: 'Buka sampai pukul 21.00',
  address: 'Jl. H. Moh. Bafadhal No.6, Cempaka Putih, Kec. Jelutung, Kota Jambi',
  rating: 4.4,
  totalReviews: 2444
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Beranda', href: '#beranda' },
    { name: 'Menu', href: '#menu' },
    { name: 'Tentang', href: '#tentang' },
    { name: 'Ulasan', href: '#ulasan' },
    { name: 'Kontak', href: '#kontak' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-red-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">AC</span>
              </div>
              <div>
                <span className="font-serif font-bold text-xl block">Aroma Cempaka</span>
                <span className="text-gray-400 text-sm">Masakan Padang</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Rumah Makan Padang terbaik di Kota Jambi dengan cita rasa autentik dari tanah Minang.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Menu Cepat</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Kontak</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${RESTAURANT_INFO.phone}`} className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors">
                  <Phone className="w-5 h-5 text-amber-500" />
                  <span>{RESTAURANT_INFO.phone}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Clock className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span>{RESTAURANT_INFO.openHours}</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{RESTAURANT_INFO.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Jam Buka</h4>
            <ul className="space-y-3">
              <li className="flex justify-between text-gray-400">
                <span>Senin - Jumat</span>
                <span>07:00 - 21:00</span>
              </li>
              <li className="flex justify-between text-gray-400">
                <span>Sabtu</span>
                <span>07:00 - 21:00</span>
              </li>
              <li className="flex justify-between text-gray-400">
                <span>Minggu</span>
                <span>07:00 - 21:00</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-gradient-to-r from-amber-500/10 to-red-500/10 rounded-xl border border-amber-500/20">
              <p className="text-sm text-amber-400 font-medium">
                Buka setiap hari untuk melayani Anda!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} {RESTAURANT_INFO.name}. Seluruh hak cipta dilindungi.
            </p>
            <div className="flex items-center gap-1 text-sm text-gray-500">
              <span>Rating</span>
              <span className="text-amber-400 font-bold">{RESTAURANT_INFO.rating} ★</span>
              <span>dari {RESTAURANT_INFO.totalReviews.toLocaleString()} ulasan</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
